import { Controller } from "@hotwired/stimulus";

// # COPIER UNE ADRESSE, ET LE DIRE
//
// Demande du porteur, 2026-09-17, sur le lien de paiement d'un tiers :
// *« il faut aussi le bouton copier le lien, avec le message qui va s'afficher — copié,
// car le bouton est cliqué »*.
//
// ## ⛔ POURQUOI PAS `clipboard_controller.js`, QUI EXISTE DÉJÀ
//
// Il fait deux choses qui ne valent pas ici :
//
//   ① il remplace l'`innerHTML` de SON PROPRE élément par « Copié ! » — le libellé du
//      bouton disparaît, et l'utilisateur perd le geste qu'il vient de faire ;
//   ② il bascule des classes **Tailwind** (`bg-cta`, `bg-gray-600`…). GO4LEARN n'a pas
//      Tailwind dans ses paquets — `go4learn_onboarding_tailwind_test` le refuse
//      nommément. Elles seraient posées sur l'élément et ne peindraient RIEN : un
//      retour visuel silencieusement mort, exactement le genre de défaut que ce dépôt
//      passe ses journées à débusquer.
//
// ⚠️ **Celui-ci laisse le bouton tranquille** et allume une phrase à côté. Le message
// vit dans le HTML (donc traduit par Rails, jamais en dur dans du JS).
export default class extends Controller {
  static targets = ["source", "message"];
  static values = { delai: { type: Number, default: 2600 } };

  async copier(event) {
    event.preventDefault();

    const texte = this.sourceTarget.value ?? this.sourceTarget.textContent.trim();

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(texte);
      } else {
        this.#copieDeRepli(texte);
      }
      this.#dire(this.messageTarget.dataset.g4lCopyDone);
    } catch {
      // ⚠️ **L'échec se DIT aussi.** Un presse-papiers refusé (contexte non sécurisé,
      // permission fermée) laisserait sinon croire que la copie a eu lieu — et l'adresse
      // partirait vide dans le message à l'oncle qui devait payer.
      this.#dire(this.messageTarget.dataset.g4lCopyFailed);
    }
  }

  // Le repli des navigateurs sans `navigator.clipboard` — `lvh.me` en HTTP en fait
  // partie, et c'est là que la recette se joue.
  #copieDeRepli(texte) {
    this.sourceTarget.removeAttribute("readonly");
    this.sourceTarget.select();
    this.sourceTarget.setSelectionRange(0, texte.length);
    const copie = document.execCommand("copy");
    this.sourceTarget.setAttribute("readonly", "readonly");
    if (!copie) throw new Error("execCommand a refusé");
  }

  #dire(phrase) {
    this.messageTarget.textContent = phrase;
    this.messageTarget.hidden = false;
    clearTimeout(this.minuteur);
    // ⚠️ Le message s'efface tout seul : une confirmation qui reste devient un décor, et
    // l'on ne sait plus si elle parle du dernier clic ou de celui d'il y a dix minutes.
    this.minuteur = setTimeout(() => {
      this.messageTarget.hidden = true;
    }, this.delaiValue);
  }

  disconnect() {
    clearTimeout(this.minuteur);
  }
}
